<template>
  <div class="m-popup">
    <div class="c-block">
      <div class="block-img-box">
        <img
          class="block-img"
          :src="
            popupInfo.coverImageRealPath ||
            require('@/assets/images/defPartner.png')
          "
        />
      </div>
      <div class="block-name">{{ popupInfo.name }}</div>
      <div class="block-content">{{ popupInfo.desc }}</div>
      <div class="block-close-icon" @click="PopupClose">
        <img src="../../assets/images/wap/icon28.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Popup",
  props: {
    popupInfo: null,
  },
  methods: {
    PopupClose() {
      this.$emit("PopupClose");
    },
  },
};
</script>

<style lang="scss" scoped></style>
